// @ts-strict-ignore
import { type GlobalModal } from 'constants/global-modal';

import { type IGlobalModalsState, type IOpenedGlobalModal } from './interfaces';

interface IStateWithGlobalModals {
  features: {
    globalModals: IGlobalModalsState;
  };
}

function getGlobalModals(state: IStateWithGlobalModals): IGlobalModalsState {
  return state.features.globalModals;
}

export function getOpenedGlobalModal(state: IStateWithGlobalModals): IOpenedGlobalModal {
  const modals = getGlobalModals(state);

  const openedModal = Object.keys(modals).find((modalName): boolean => modals[modalName].displayed) as GlobalModal;

  if (openedModal) {
    return {
      modalType: openedModal,
      ...modals[openedModal],
    };
  }

  return null;
}
